import { useEffect, useMemo, useState } from "react";

export const usePatientData = (
  patient,
  getHealthScore,
  getPatientsSymptom,
  getPatientImageAnalysisStore,
  getPatientQuestionAnswer
) => {
  const [recommendations, setRecommendations] = useState(null);
  const [symptomNames, setSymptomNames] = useState([]);
  const [imageAnalysisReportList, setImageAnalysisReportList] = useState([]);
  const [patientQuestionAnswer, setPatientQuestionAnswer] = useState([]);

  useEffect(() => {
    if (patient) {
      getHealthScore(patient.mobile.replace("+91", "")).then((res) => {
        setRecommendations(res);
      });

      getPatientsSymptom(patient.patientId).then((res) => {
        const symptomNames = [];

        res?.forEach((record) => {
          record.attributes.symptoms.data.forEach((symptom) => {
            symptomNames.push(symptom.attributes.name);
          });
        });

        const uniqueSymptomNames = [...new Set(symptomNames)];

        setSymptomNames(uniqueSymptomNames);
      });

      getPatientQuestionAnswer("Medical History 1", patient.patientId).then(
        (res) => {
          const updatedQuestionAnswerList = res.map((item) => {
            return {
              id: item.id,
              text: toTitleCase(item.attributes.question_text),
              options: item.attributes.question_values.map((option, index) => {
                return {
                  id: index.toString(),
                  label: toTitleCase(option),
                };
              }),
              userAnswer: item.answer,
            };
          });

          setPatientQuestionAnswer(updatedQuestionAnswerList);
        }
      );

      getPatientImageAnalysisStore(patient.patientId).then((res) => {
        const updatedImageList = res.map((item) => {
          return {
            id: item.id,
            text: toTitleCase(item.attributes.image_description),
            type: item.attributes.media_type,
            title: toTitleCase(item.attributes.analysis_type),
            url: item.attributes.media.data[0].attributes.url,
          };
        });

        setImageAnalysisReportList(updatedImageList);
      });
    }
  }, [
    patient,
    getHealthScore,
    getPatientsSymptom,
    getPatientQuestionAnswer,
    getPatientImageAnalysisStore,
  ]);

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split("_") // First split by underscores
      .join(" ") // Replace _ with space
      .split(" ") // Then split by spaces
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const filteredRecommendation = useMemo(() => {
    if (recommendations) {
      return Object.keys(recommendations).filter(
        (key) =>
          recommendations[key].score &&
          (key === "Sleep Score" ||
            key === "Stress Score" ||
            key === "Prakriti")
      );
    }
    return [];
  }, [recommendations]);

  return {
    recommendations,
    symptomNames,
    imageAnalysisReportList,
    patientQuestionAnswer,
    filteredRecommendation,
    toTitleCase,
  };
};

export default usePatientData;
